// extracted by mini-css-extract-plugin
module.exports = {"info":"lastBlogposts-module--info--3M60P"};